(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-faq-smooth"] && !Shopify.designMode) return;
  try {
    
(function() {
  function initAccordion() {
    const faqButtons = document.querySelectorAll(".accordion-btn");
    faqButtons.forEach(btn => {
      btn.addEventListener("click", function() {
        const content = btn.nextElementSibling;
        const isOpen = content.style.maxHeight && content.style.maxHeight !== "0px";

        // Close all other items
        document.querySelectorAll(".accordion-content").forEach(c => {
          c.style.maxHeight = null;
        });
        document.querySelectorAll(".accordion-btn svg").forEach(svg => {
          svg.classList.remove("rotate-180");
        });

        // Toggle clicked item
        if (!isOpen) {
          content.style.maxHeight = content.scrollHeight + "px";
          btn.querySelector("svg").classList.add("rotate-180");
        }
      });
    });
  }

  if (document.readyState === "complete" || document.readyState === "interactive") {
    setTimeout(initAccordion, 100);
  } else {
    document.addEventListener("DOMContentLoaded", initAccordion);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["explore-all-products"] && !Shopify.designMode) return;
  try {
    
(() => {
  const slides = document.querySelector('.explore-all-slides');
  const prevBtn = document.querySelector('#explore-all-prev-btn');
  const nextBtn = document.querySelector('#explore-all-next-btn');
  const totalSlides = slides.children.length;
  let currentIndex = 0;

  // Calculate slides per view
  function slidesPerView() {
    const width = window.innerWidth;
    if (width >= 1024) return 3;
    if (width >= 768) return 2;
    return 1;
  }

  // Core update function
  function updateCarousel() {
    const spv = slidesPerView();
    const maxIndex = totalSlides - spv;
    currentIndex = Math.max(0, Math.min(currentIndex, maxIndex));

    const translatePercent = -(currentIndex * (100 / spv));
    slides.style.transition = 'transform 0.4s ease';
    slides.style.transform = `translateX(${translatePercent}%)`;

    prevBtn.disabled = currentIndex === 0;
    nextBtn.disabled = currentIndex === maxIndex;
  }

  // Navigation buttons
  prevBtn.addEventListener('click', () => {
    currentIndex--;
    updateCarousel();
  });

  nextBtn.addEventListener('click', () => {
    currentIndex++;
    updateCarousel();
  });

  // --- Swipe Support (Simplified version that just works) ---
  let startX = 0;
  let endX = 0;
  let isTouching = false;

  slides.addEventListener('touchstart', (e) => {
    if (window.innerWidth >= 1024) return; // only mobile/tablet
    isTouching = true;
    startX = e.touches[0].clientX;
    slides.style.transition = 'none'; // disable transition while dragging
  });

  slides.addEventListener('touchmove', (e) => {
    if (!isTouching) return;
    const currentX = e.touches[0].clientX;
    const deltaX = currentX - startX;
    const spv = slidesPerView();
    const movePercent = (deltaX / slides.clientWidth) * 100;
    const baseTranslate = -(currentIndex * (100 / spv));
    slides.style.transform = `translateX(${baseTranslate + movePercent}%)`;
  });

  slides.addEventListener('touchend', (e) => {
    if (!isTouching) return;
    isTouching = false;
    endX = e.changedTouches[0].clientX;
    const diff = startX - endX;

    const spv = slidesPerView();
    const threshold = slides.clientWidth * 0.1; // 10% swipe threshold

    // Swipe left
    if (diff > threshold && currentIndex < totalSlides - spv) {
      currentIndex++;
    }
    // Swipe right
    else if (diff < -threshold && currentIndex > 0) {
      currentIndex--;
    }

    updateCarousel();
  });

  // --- Resize handling ---
  window.addEventListener('resize', () => {
    updateCarousel();
  });

  // --- Init ---
  updateCarousel();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gemstones-calculator"] && !Shopify.designMode) return;
  try {
    
    // ========================== CONFIG: gemstone images ==========================
    // ========================== CONSTS / DATA ==========================
const GS_IMAGES = {
  ruby: 'assets/gemstones/ruby.jpg',
  emerald: 'assets/gemstones/emerald.jpg',
  blueSapphire: 'assets/gemstones/blue-sapphire.jpg',
  yellowSapphire: 'assets/gemstones/yellow-sapphire.jpg'
};

// Guide list data (with Hindi labels & finger mapping)
const GEMSTONE_GUIDE = [
  { name: "Yellow Sapphire", hindi: "पुखराज", finger: "Index Finger", fingerHindi: "तर्जनी", image: GS_IMAGES.yellowSapphire },
  { name: "Cat's Eye", hindi: "लहसुनिया", finger: "Middle Finger", fingerHindi: "मध्यमा", image: GS_IMAGES.ruby },
  { name: "Blue Sapphire", hindi: "नीलम", finger: "Middle Finger", fingerHindi: "मध्यमा", image: GS_IMAGES.blueSapphire },
  { name: "Opal", hindi: "दूधिया पत्थर", finger: "Middle Finger", fingerHindi: "मध्यमा", image: GS_IMAGES.emerald },
  { name: "Hessonite", hindi: "गोमेद", finger: "Middle Finger", fingerHindi: "मध्यमा", image: GS_IMAGES.ruby },
  { name: "Ruby", hindi: "माणिक", finger: "Ring Finger", fingerHindi: "अनामिका", image: GS_IMAGES.ruby },
  { name: "Pearl", hindi: "मोती", finger: "Little Finger", fingerHindi: "कनिष्ठिका", image: GS_IMAGES.emerald },
  { name: "Red Coral", hindi: "मूंगा", finger: "Ring Finger", fingerHindi: "अनामिका", image: GS_IMAGES.ruby },
  { name: "Emerald", hindi: "पन्ना", finger: "Little Finger", fingerHindi: "कनिष्ठिका", image: GS_IMAGES.emerald },
];

// ========================== STATE ==========================
let gsStep = 1;
const gsTotalSteps = 3;



const gsFormData = {
  name: '', email: '', phone: '',
  gender: '', weight: '',
  birthDate: '', birthTime: '',
  birthPlace: '',
  // extra from place API:
  latDeg: '', latMin: '', latNS: '',
  longDeg: '', longMin: '', longEW: '',
  timeZone: '', timezoneId: '',
  state: '', country: ''
};

function buildParamsFromForm() {
  let data = gsFormData;

  const [year, month, day] = (data.birthDate || '').split("-");
  const [hrs, min] = (data.birthTime || '').split(":");

  const genderFormatted = data.gender
    ? data.gender.charAt(0).toUpperCase() + data.gender.slice(1)
    : '';

  const params = new URLSearchParams({
    PerInfo_name: data.name,
    PerInfo_gender: genderFormatted,
    day,
    month,
    year,
    hrs,
    min,
    sec: "00",

    txtPlace: data.birthPlace || '',

    // ✅ Use values filled from FindPlaces API
    latDeg:  data.latDeg  || "0",
    latMin:  data.latMin  || "0",
    latNS:   data.latNS   || "N",
    longDeg: data.longDeg || "0",
    longMin: data.longMin || "0",
    longEW:  data.longEW  || "E",

    timeZone: data.timeZone || "5.5",

    dst: "0",
    ayanamsa: "0",
    country_code: "91",
    mobile_number: data.phone || '',
    email: data.email || '',
    Pc_Name: "gemstone",
    languageCode: "0"
  });

  return params;
}

// ========================== HELPERS ==========================
const $ = (sel, root = document) => root.querySelector(sel);
const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));
const show = (el) => el && el.classList.remove('gs-hidden');
const hide = (el) => el && el.classList.add('gs-hidden');

function updateProgress() {
  const badge = $('#gs-stepBadge');
  const progress = $('#gs-progress');
  if (badge) badge.textContent = `Step ${gsStep} of ${gsTotalSteps}`;
  if (progress) progress.style.width = `${(gsStep / gsTotalSteps) * 100}%`;
  // Buttons
  const prevBtn = $('#gs-prev');
  const nextBtn = $('#gs-next');
  if (prevBtn) {
    if (gsStep > 1) show(prevBtn); else hide(prevBtn);
  }
  if (nextBtn) nextBtn.textContent = gsStep < gsTotalSteps ? 'Next Step' : 'Get My Gemstone';
}

function switchStep(next) {
  const steps = $$('.gs-step');
  steps.forEach(s => hide(s));
  const current = $(`.gs-step[data-step="${next}"]`);
  if (current) show(current);
  gsStep = next;
  updateProgress();
}

function toast(msg, type = 'info') {
  const el = $('#gs-toast');
  if (!el) {
    console.log('Toast:', msg);
    return;
  }
  el.textContent = msg;
  el.style.borderColor = type === 'error' ? 'rgba(255,112,112,.5)' : 'var(--gs-border)';
  el.classList.add('show');
  setTimeout(() => el.classList.remove('show'), 2000);
}

function clearErrors(fields) {
  fields.forEach(f => {
    const err = document.querySelector(`.gs-error[data-error-for="${f}"]`);
    if (err) err.textContent = '';
  });
}

function setError(field, message) {
  const err = document.querySelector(`.gs-error[data-error-for="${field}"]`);
  if (err) err.textContent = message || '';
}

 const phoneInput = document.getElementById('gs-phone');
 const errorDiv = document.querySelector('[data-error-for="phone"]');

    // Country data: code, name, and number length (mainly mobile)
    const countries = [
      { code: '+1', name: 'United States/Canada', length: 10, format: '($1) $2-$3' },
      { code: '+44', name: 'United Kingdom', length: 10 },
      { code: '+91', name: 'India', length: 10 },
      { code: '+61', name: 'Australia', length: 9 },
      { code: '+81', name: 'Japan', length: 10 },
      { code: '+49', name: 'Germany', length: 11 },
      { code: '+33', name: 'France', length: 9 },
      { code: '+39', name: 'Italy', length: 10 },
      { code: '+34', name: 'Spain', length: 9 },
      { code: '+55', name: 'Brazil', length: 11 },
      { code: '+7', name: 'Russia', length: 10 },
      { code: '+86', name: 'China', length: 11 },
      { code: '+82', name: 'South Korea', length: 10 },
      { code: '+27', name: 'South Africa', length: 9 },
      { code: '+64', name: 'New Zealand', length: 9 },
      { code: '+31', name: 'Netherlands', length: 9 },
      { code: '+46', name: 'Sweden', length: 9 },
      { code: '+41', name: 'Switzerland', length: 9 },
      { code: '+52', name: 'Mexico', length: 10 },
      { code: '+65', name: 'Singapore', length: 8 },
    ];

    // Helper: find country by prefix
    function getCountryByPrefix(num) {
      return countries.find(c => num.startsWith(c.code));
    }

    // Format input dynamically
    phoneInput.addEventListener('input', (e) => {
      let val = e.target.value.replace(/[^\d+]/g, ''); // only digits and '+'
      
      // Ensure starts with '+'
      if (!val.startsWith('+') && val.length > 0) {
        val = '+' + val;
      }

      const country = getCountryByPrefix(val);
      if (country) {
        // Extract digits after country code
        const digits = val.replace(country.code, '').replace(/\D/g, '');

        // For India or other countries, format spacing simply
        let formatted = country.code + ' ';

        if (country.code === '+91' && digits.length > 0) {
          // Indian format: +91 XXXXX XXXXX
          formatted += digits.substring(0, 5);
          if (digits.length > 5) formatted += ' ' + digits.substring(5, 10);
        } else if (country.code === '+1' && digits.length > 0) {
          // US/Canada format: +1 (XXX) XXX-XXXX
          if (digits.length <= 3) formatted += '(' + digits;
          else if (digits.length <= 6) formatted += '(' + digits.substring(0,3) + ') ' + digits.substring(3);
          else formatted += '(' + digits.substring(0,3) + ') ' + digits.substring(3,6) + '-' + digits.substring(6,10);
        } else {
          // Generic formatting for others
          formatted += digits;
        }

        e.target.value = formatted.trim();
      } else {
        e.target.value = val;
      }

      // Validation
      validatePhone();
    });

    function validatePhone() {
      const val = phoneInput.value.replace(/\D/g, ''); // only digits
      let ok = true;
      let message = '';

      // Detect country by prefix or assume India if only 10 digits
      let country = getCountryByPrefix(phoneInput.value);
      if (!country && val.length === 10) {
        country = countries.find(c => c.code === '+91');
        phoneInput.value = '+91 ' + val.substring(0,5) + ' ' + val.substring(5);
      }

      if (!country) {
        message = 'Unknown country code';
        ok = false;
      } else {
        const nationalDigits = val.replace(country.code.replace('+',''), '');
        if (nationalDigits.length !== country.length) {
          message = `${country.name} numbers must be ${country.length} digits`;
          ok = false;
        }
      }

      errorDiv.textContent = ok ? '' : message;
      return ok;
    }

// ========================== VALIDATION ==========================
function validateStep(step) {
  let ok = true;
  if (step === 1) {
    clearErrors(['name','email','phone']);
    if (!gsFormData.name || gsFormData.name.trim().length < 2) {
      setError('name','Name must be at least 2 characters'); ok = false;
    }
    const emailOk = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(gsFormData.email || '');
    if (!emailOk) {
      setError('email','Invalid email address'); ok = false;
    }
   if (!gsFormData.phone) {
  setError('phone', 'Phone number is required');
  ok = false;
} else {
  const digitsOnly = gsFormData.phone.replace(/\D/g, ''); // keep only digits
  const countries = [
    { code: '+1', length: 10 },
    { code: '+44', length: 10 },
    { code: '+91', length: 10 },
    { code: '+61', length: 9 },
    { code: '+81', length: 10 },
    { code: '+49', length: 11 },
    { code: '+33', length: 9 },
    { code: '+39', length: 10 },
    { code: '+34', length: 9 },
    { code: '+55', length: 11 },
    { code: '+7', length: 10 },
    { code: '+86', length: 11 },
    { code: '+82', length: 10 },
    { code: '+27', length: 9 },
    { code: '+64', length: 9 },
    { code: '+31', length: 9 },
    { code: '+46', length: 9 },
    { code: '+41', length: 9 },
    { code: '+52', length: 10 },
    { code: '+65', length: 8 },
  ];

  const country = countries.find(c => gsFormData.phone.startsWith(c.code));

  if (country) {
    const nationalNumber = digitsOnly.slice(country.code.replace('+','').length);
    if (nationalNumber.length !== country.length) {
      setError('phone', `Phone number must be ${country.length} digits for ${country.code}`);
      ok = false;
    }
  } else if (digitsOnly.length === 10) {
    // Assume India if no code but 10 digits
    gsFormData.phone = '+91 ' + digitsOnly.substring(0,5) + ' ' + digitsOnly.substring(5);
  } else {
    setError('phone', 'Enter a valid phone number with correct country code');
    ok = false;
  }
}

  }
  if (step === 2) {
    clearErrors(['gender','weight','birthDate']);
    if (!gsFormData.gender) { setError('gender','Please select gender'); ok = false; }
    if (!gsFormData.weight) { setError('weight','Weight is required'); ok = false; }
    if (!gsFormData.birthDate) { setError('birthDate','Birth date is required'); ok = false; }
  }
  if (step === 3) {
    clearErrors(['birthTime','birthPlace']);
    if (!gsFormData.birthTime) { setError('birthTime','Birth time is required'); ok = false; }
    if (!gsFormData.birthPlace || gsFormData.birthPlace.trim().length < 2) {
      setError('birthPlace','Birth place is required'); ok = false;
    }
  }
  return ok;
}

// ========================== READ INPUTS INTO STATE ==========================
function readInputsIntoState() {
  // Read current visible step inputs into gsFormData
  const stepEl = $(`.gs-step[data-step="${gsStep}"]`);
  if (!stepEl) return;
  $$('.gs-input, .gs-select, .gs-date, .gs-time', stepEl).forEach(input => {
    if (!input.name) return;
    // For radio/checkbox groups, handle separately if needed
    if (input.type === 'radio') {
      const checked = stepEl.querySelector(`input[name="${input.name}"]:checked`);
      if (checked) gsFormData[input.name] = checked.value;
    } else {
      gsFormData[input.name] = input.value;
    }
  });

  // Also capture commonly present fields (in case they are outside current step)
  const globalFields = ['name','email','phone','gender','weight','birthDate','birthTime','birthPlace'];
  globalFields.forEach(fn => {
    const el = document.querySelector(`[name="${fn}"]`);
    if (el) {
      if (el.type === 'radio') {
        const checked = document.querySelector(`input[name="${fn}"]:checked`);
        if (checked) gsFormData[fn] = checked.value;
      } else {
        gsFormData[fn] = el.value || gsFormData[fn];
      }
    }
  });
}

// ========================== RESULTS / RESET ==========================
function showResults() {
  hide($('#gs-form'));
  show($('#gs-results'));
  // Basic demo logic (you could derive stones from form fields if needed)
  const primary = $('#gs-img-primary');
  const secondary = $('#gs-img-secondary');
  if (primary) primary.src = GS_IMAGES.blueSapphire;
  if (secondary) secondary.src = GS_IMAGES.yellowSapphire;
}

function resetAll() {
  // Reset state
  Object.keys(gsFormData).forEach(k => gsFormData[k] = '');
  // Reset inputs
  $$('#gs-form input, #gs-form select').forEach(el => el.value = '');
  // Hide results, show form
  hide($('#gs-results'));
  show($('#gs-form'));
  switchStep(1);
}

// ========================== INIT & EVENTS ==========================
updateProgress();

// Next / Prev buttons
const nextBtn = $('#gs-next');
const prevBtn = $('#gs-prev');
if (nextBtn) {
  nextBtn.addEventListener('click', () => {
    readInputsIntoState();
    if (!validateStep(gsStep)) {
      toast('Please check the highlighted fields', 'error');
      return;
    }
   
    if (gsStep < gsTotalSteps) {
      switchStep(gsStep + 1);
    } else {
      callGemstoneAPI();  // API Call on final step


 
  let data = gsFormData
  const [year, month, day] = data.birthDate.split("-");
  const [hrs, min] = data.birthTime.split(":");

 
 
const url = `https://bt.astrosage.com/rashiproductcalculater?${params.toString()}`;

fetch(url)
  .then(res => {
    if (!res.ok) {
      throw new Error(`HTTP error from calculator! Status: ${res.status}`);
    }
    return res.json();
  })
  .then(calcData => {
    console.log('🧮 Calculator result:', calcData);
    showResults();    
    
    return fetch(`/products/${calcData[0].url_text}.json`);
  })
  .then(response => {
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    return response.json();
  })
  .then(data => { 
    let grid = document.querySelector('.gs-result-grid');
    if (!grid) {
      grid = document.createElement('div');
      grid.className = 'gs-result-grid';
      grid.style.marginTop = '16px';
      document.body.appendChild(grid);
    }
    grid.innerHTML = ""

    
    const card = document.createElement('article');
    card.className = 'gs-card-soft';
    card.innerHTML = `
      <img id="gs-img-primary" alt="${data.product?.title || 'Product Image'}" 
           src="${data.product?.image?.src || ''}" />
      <div class="gs-card-soft-inner">
        <h4 style="font-size:18px; font-weight:800; margin-bottom:6px;">
            ${data.product?.title || ''} 
        </h4>
        <p style="color:var(--gs-muted); font-size:14px; margin-bottom:10px;">
          ${data.product?.description || ''}
        </p>
        <a href="/products/${data.product?.handle || ''}" class="gs-btn block">Buy Now</a>
      </div>
    `;

    
    grid.appendChild(card);

    
    console.log('🎉 All steps completed. Final Form Data:', {...gsFormData});

    toast('Calculation Complete!');
  })
  .catch(err => {
    console.error('Error in flow:', err);
    // optional: toast('Something went wrong, please try again.');
  });




      console.log('🎉 All steps completed. Final Form Data:', {
        ...gsFormData,
      });

      showResults();
      toast('Calculation Complete!');
    }
  });










  

}


if (prevBtn) {
  prevBtn.addEventListener('click', () => {
    if (gsStep > 1) switchStep(gsStep - 1);
  });
}

// Live clear error on input/change
$$('#gs-form input, #gs-form select').forEach(el => {
  el.addEventListener('input', () => {
    const f = el.name;
    if (!f) return;
    setError(f, '');
  });
  el.addEventListener('change', () => {
    const f = el.name;
    if (!f) return;
    setError(f, '');
  });
});

// Calculate Again
const againBtn = $('#gs-again');
if (againBtn) {
  againBtn.addEventListener('click', resetAll);
}

function logStepData(step) {
  if (step === 1) {
    console.log('✅ Step 1 completed. Data:', {
      name: gsFormData.name,
      email: gsFormData.email,
      phone: gsFormData.phone,
    });
  } else if (step === 2) {
    console.log('✅ Step 2 completed. Data:', {
         name: gsFormData.name,
      email: gsFormData.email,
      phone: gsFormData.phone,
      gender: gsFormData.gender,
      weight: gsFormData.weight,
      birthDate: gsFormData.birthDate,
    });
  } else if (step === 3) {
    console.log('✅ Step 3 completed. Data:', {
         name: gsFormData.name,
      email: gsFormData.email,
      phone: gsFormData.phone,
      gender: gsFormData.gender,
      weight: gsFormData.weight,
      birthDate: gsFormData.birthDate,
      birthTime: gsFormData.birthTime,
      birthPlace: gsFormData.birthPlace,
    });
  }
}


 

const birthInput = document.getElementById('gs-birthPlace');
  const suggestionBox = document.querySelector('.gs-suggestion-places ul');
  const suggestionContainer = document.querySelector('.gs-suggestion-places');

  // Debounce helper
  function debounce(fn, delay) {
    let timer;
    return function(...args) {
      clearTimeout(timer);
      timer = setTimeout(() => fn.apply(this, args), delay);
    };
  }

 
  // Debounced input listener
  const debouncedFetch = debounce(() => fetchPlaces(birthInput.value), 400);
  birthInput.addEventListener('input', debouncedFetch);

  // Optional: Hide suggestions when clicking outside
  document.addEventListener('click', (e) => {
    if (!suggestionContainer.contains(e.target) && e.target !== birthInput) {
      suggestionContainer.classList.remove('show');
    }
  });


document.addEventListener('DOMContentLoaded', function () {
  const birthInput = document.getElementById('gs-birthDate');
  if (!birthInput) return;

  // Open calendar when user clicks the field
  birthInput.addEventListener('click', function () {
    if (this.showPicker) {
      this.showPicker(); // Modern browsers
    } else {
      this.focus();      // Fallback
    }
  });

  // Also open when it gets focus (e.g. via tab key)
  birthInput.addEventListener('focus', function () {
    if (this.showPicker) {
      this.showPicker();
    }
  });
});


document.addEventListener('DOMContentLoaded', function () {
  const weightInput = document.getElementById('gs-weight');
  if (!weightInput) return;

  // Disable scroll increment/decrement
  weightInput.addEventListener('wheel', function (event) {
    this.blur();
  });

  // Prevent entering negative numbers, e, +, -
  weightInput.addEventListener('keydown', function (event) {
    if (
      event.key === 'e' ||
      event.key === 'E' ||
      event.key === '+' ||
      event.key === '-' ||
      event.key === '.'
    ) {
      event.preventDefault();
    }
  });

  // Prevent manually typing negative numbers or invalid chars
  weightInput.addEventListener('input', function () {
    if (this.value < 0) this.value = '';
    this.value = this.value.replace(/[^0-9]/g, '');
  });

  // Open numeric keypad when focused (especially for mobile)
  weightInput.addEventListener('focus', function () {
    this.setAttribute('inputmode', 'numeric');
    this.setAttribute('pattern', '[0-9]*');
  });
});


document.addEventListener('DOMContentLoaded', function () {
  const timeInput = document.getElementById('gs-birthTime');
  if (!timeInput) return;

  // Open time picker on click or focus
  const openTimePicker = function () {
    if (this.showPicker) {
      this.showPicker(); // For modern browsers
    } else {
      this.focus();      // Fallback for others
    }
  };

  timeInput.addEventListener('click', openTimePicker);
  timeInput.addEventListener('focus', openTimePicker);

  // Prevent manual typing of invalid time characters
  timeInput.addEventListener('keydown', function (event) {
    event.preventDefault(); // Disable keyboard typing
  });
});





async function fetchPlaces(query) {
  if (!query.trim()) {
    suggestionContainer.classList.remove('show');
    suggestionBox.innerHTML = '';
    return;
  }

  const url = `https://bt.astrosage.com/FindPlaces?q=${encodeURIComponent(query)}`;

  try {
    const res = await fetch(url);
    if (!res.ok) throw new Error(`HTTP error! Status: ${res.status}`);

    const textData = await res.text();
console.log(textData)
    // No data
    const lines = textData
      .split('\n')
      .map(l => l.trim())
      .filter(Boolean);

    if (!lines.length) {
      suggestionContainer.classList.remove('show');
      suggestionBox.innerHTML = '';
      return;
    }

    // Parse each line: City|State|Country|latDeg|latMin|latNS|longDeg|longMin|longEW|timeZone|timezoneId
    const places = lines.map(line => {
      const parts = line.split('|');
      return {
        city:       parts[0] || '',
        state:      parts[1] || '',
        country:    parts[2] || '',
        latDeg:     parts[3] || '',
        latMin:     parts[4] || '',
        latNS:      parts[5] || '',
        longDeg:    parts[6] || '',
        longMin:    parts[7] || '',
        longEW:     parts[8] || '',
        timeZone:   parts[9] || '',
        timezoneId: parts[10] || ''
      };
    });

    // Build suggestion list
    suggestionBox.innerHTML = places.map((p, idx) => `
      <li
        data-index="${idx}"
        data-city="${p.city}"
        data-state="${p.state}"
        data-country="${p.country}"
        data-lat-deg="${p.latDeg}"
        data-lat-min="${p.latMin}"
        data-lat-ns="${p.latNS}"
        data-long-deg="${p.longDeg}"
        data-long-min="${p.longMin}"
        data-long-ew="${p.longEW}"
        data-time-zone="${p.timeZone}"
        data-timezone-id="${p.timezoneId}"
      >
        ${p.city}, ${p.state}, ${p.country}
      </li>
    `).join('');

    suggestionContainer.classList.add('show');

    // Attach click handler to each <li>
    suggestionBox.querySelectorAll('li').forEach(li => {
      li.addEventListener('click', () => {
        const city       = li.dataset.city;
        const state      = li.dataset.state;
        const country    = li.dataset.country;
        const latDeg     = li.dataset.latDeg;
        const latMin     = li.dataset.latMin;
        const latNS      = li.dataset.latNs;
        const longDeg    = li.dataset.longDeg;
        const longMin    = li.dataset.longMin;
        const longEW     = li.dataset.longEw;
        const timeZone   = li.dataset.timeZone;
        const timezoneId = li.dataset.timezoneId;

        const fullPlace = `${city}, ${state}, ${country}`;

        // Set input value
        birthInput.value = fullPlace;

        // 🔐 Save into gsFormData for later param building
        gsFormData.birthPlace = fullPlace;
        gsFormData.latDeg     = latDeg;
        gsFormData.latMin     = latMin;
        gsFormData.latNS      = latNS;
        gsFormData.longDeg    = longDeg;
        gsFormData.longMin    = longMin;
        gsFormData.longEW     = longEW;
        gsFormData.timeZone   = timeZone;
        gsFormData.timezoneId = timezoneId;
        gsFormData.state      = state;
        gsFormData.country    = country;

        // Hide suggestions
        suggestionContainer.classList.remove('show');
        suggestionBox.innerHTML = '';
      });
    });

  } catch (err) {
    console.error('Error fetching places:', err);
    suggestionContainer.classList.remove('show');
    suggestionBox.innerHTML = '';
  }
}

birthInput.addEventListener('input', debounce((e) => {
  fetchPlaces(e.target.value);
}, 300));  // Pass a function that calls fetchPlaces


 

function buildParamsFromForm() {
  let data = gsFormData;

  const [year, month, day] = (data.birthDate || '').split("-");
  const [hrs, min] = (data.birthTime || '').split(":");

  const genderFormatted = data.gender ? data.gender.charAt(0).toUpperCase() + data.gender.slice(1) : '';

  const params = new URLSearchParams({
    PerInfo_name: data.name,
    PerInfo_gender: genderFormatted,
    day,
    month,
    year,
    hrs,
    min,
    sec: "00",
    txtPlace: data.birthPlace || '',
    latDeg:  data.latDeg  || "0",
    latMin:  data.latMin  || "0",
    latNS:   data.latNS   || "N",
    longDeg: data.longDeg || "0",
    longMin: data.longMin || "0",
    longEW:  data.longEW  || "E",
    timeZone: data.timeZone || "5.5",
    dst: "0",
    ayanamsa: "0",
    country_code: "91",
    mobile_number: data.phone || '',
    email: data.email || '',
    Pc_Name: "gemstone",
    languageCode: "0"
  });

  return params;
}

// ========================== API CALL FUNCTION ==========================
function callGemstoneAPI() {
  const params = buildParamsFromForm();
  const url = `https://bt.astrosage.com/rashiproductcalculater?${params.toString()}`;

  fetch(url)
    .then(res => {
      if (!res.ok) {
        throw new Error(`HTTP error from calculator! Status: ${res.status}`);
      }
      return res.json();
    })
    .then(calcData => {
      console.log('🧮 Calculator result:', calcData);
      showResults();
      
      return fetch(`/products/${calcData[0].url_text}.json`);
    })
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      return response.json();
    })
    .then(data => {
      let grid = document.querySelector('.gs-result-grid');
      if (!grid) {
        grid = document.createElement('div');
        grid.className = 'gs-result-grid';
        grid.style.marginTop = '16px';
        document.body.appendChild(grid);
      }

      const card = document.createElement('article');
      card.className = 'gs-card-soft';
      card.innerHTML = `
        <img id="gs-img-primary" alt="${data.product?.title || 'Product Image'}" 
             src="${data.product?.image?.src || ''}" />
        <div class="gs-card-soft-inner">
          <h4 style="font-size:18px; font-weight:800; margin-bottom:6px;">
              ${data.product?.title || ''} 
          </h4>
          <p style="color:var(--gs-muted); font-size:14px; margin-bottom:10px;">
            ${data.product?.description || ''}
          </p>
          <a href="/products/${data.product?.handle || ''}" class="gs-btn block">Buy Now</a>
        </div>
      `;

      grid.appendChild(card);
      console.log('🎉 All steps completed. Final Form Data:', {...gsFormData});

      toast('Calculation Complete!');
    })
    .catch(err => {
      console.error('Error in flow:', err);
      toast('Something went wrong, please try again.', 'error');
    });
}


function readInputsIntoState() {
  // Read current visible step inputs into gsFormData
  const stepEl = $(`.gs-step[data-step="${gsStep}"]`);
  if (!stepEl) return;
  $$('.gs-input, .gs-select, .gs-date, .gs-time', stepEl).forEach(input => {
    if (!input.name) return;
    // For radio/checkbox groups, handle separately if needed
    if (input.type === 'radio') {
      const checked = stepEl.querySelector(`input[name="${input.name}"]:checked`);
      if (checked) gsFormData[input.name] = checked.value;
    } else {
      gsFormData[input.name] = input.value;
    }
  });
}

// Show results after API call
function showResults() {
  hide($('#gs-form'));
  show($('#gs-results'));
}



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-section-homepage"] && !Shopify.designMode) return;
  try {
    


document.addEventListener('DOMContentLoaded', function() {
  // Select all carousels
  const carousels = document.querySelectorAll('.carousel');

  carousels.forEach(carousel => {
    const container = carousel.querySelector('.carouselContainer');
    const prevBtn = carousel.querySelector('.pr-card-aa-prev-button');
    const nextBtn = carousel.querySelector('.pr-card-aa-next-button');

    if (!container || !prevBtn || !nextBtn) return; // safety check

    const slides = container.children;
    let currentIndex = 0;
    let slideWidth = slides[0].offsetWidth + 8; // initial for mobile

    function updateSlideWidth() {
      const isMobile = window.innerWidth < 768;
      slideWidth = isMobile ? slides[0].offsetWidth + 8 : 0;
    }

    function updateCarousel() {
      const isMobile = window.innerWidth < 768;
      if (!isMobile) {
        container.style.transform = 'translate3d(0px, 0px, 0px)';
        currentIndex = 0;
        return;
      }
      const translateX = -currentIndex * slideWidth;
      container.style.transform = `translate3d(${translateX}px, 0px, 0px)`;
    }

    // Initialize
    updateSlideWidth();
    updateCarousel();

    // Next & Prev buttons
    nextBtn.addEventListener('click', () => {
      if (window.innerWidth < 768 && currentIndex < slides.length - 1) {
        currentIndex++;
        updateCarousel();
      }
    });

    prevBtn.addEventListener('click', () => {
      if (window.innerWidth < 768 && currentIndex > 0) {
        currentIndex--;
        updateCarousel();
      }
    });

    // Swipe Support
    let startX = 0;
    let endX = 0;

    container.addEventListener('touchstart', e => {
      if (window.innerWidth >= 768) return;
      startX = e.touches[0].clientX;
    });

    container.addEventListener('touchend', e => {
      if (window.innerWidth >= 768) return;
      endX = e.changedTouches[0].clientX;
      if (startX - endX > 50 && currentIndex < slides.length - 1) {
        currentIndex++;
      } else if (endX - startX > 50 && currentIndex > 0) {
        currentIndex--;
      }
      updateCarousel();
    });

    // Resize Handling
    window.addEventListener('resize', () => {
      updateSlideWidth();
      updateCarousel();
    });
  });
});



// document.addEventListener('alpine:init', () => {
//     Alpine.data('xProductCart', () => ({
//       items: [], // Array to store cart items
//       total: 0, // Total price
//       loading: false, // Loading state for async operations
//       success: false, // Success state for UI feedback
//       errorMessage: '', // Error message for failed operations

//       async addToCart(event, validate = false) {
//         event.preventDefault();
//           console.log("1");
//         if (this.loading) return;

//         this.loading = true;
//         this.success = false;
//         this.errorMessage = '';

//         const form = event.target.closest('form');
//         const formData = new FormData(form);

//         try {
//               console.log("2");
//           const response = await fetch('/cart/add.js', {
//             method: 'POST',
//             body: formData,
//             headers: {
//               'Accept': 'application/json',
//             },
//           });

//           if (!response.ok) {
//             const errorData = await response.json();
//             this.errorMessage = errorData.description || 'Failed to add to cart';
//             this.loading = false;
//             return;
//           }

//           // Fetch updated cart after adding item (Shopify-specific)
//           const cartResponse = await fetch('/cart.js', {
//             headers: { 'Accept': 'application/json' },
//           });
//           const cartData = await cartResponse.json();
//           console.log(cartData);
          

//           // Update reactive state
//           this.items = cartData.items || [];
//           this.total = cartData.total_price / 100; // Shopify returns cents
//           this.success = true;

//           // Reset success state after a delay
//           setTimeout(() => {
//             this.success = false;
//             this.loading = false;
//           }, 2000);
//         } catch (error) {
//           this.errorMessage = 'Network error, please try again.';
//           this.loading = false;
//         }
//       },

//       async removeItem(variantId) {
//         if (this.loading) return;
//         this.loading = true;
//         this.errorMessage = '';

//         try {
//           const response = await fetch('/cart/change.js', {
//             method: 'POST',
//             headers: {
//               'Content-Type': 'application/json',
//               'Accept': 'application/json',
//             },
//             body: JSON.stringify({ id: variantId, quantity: 0 }),
//           });

//           if (!response.ok) {
//             const errorData = await response.json();
//             this.errorMessage = errorData.description || 'Failed to remove item';
//             this.loading = false;
//             return;
//           }

//           // Update cart state
//           const cartResponse = await fetch('/cart.js', {
//             headers: { 'Accept': 'application/json' },
//           });
//           const cartData = await cartResponse.json();
//           console.log(cartData)
//           this.items = cartData.items || [];
//           this.total = cartData.total_price / 100;
//         } catch (error) {
//           this.errorMessage = 'Network error, please try again.';
//           this.loading = false;
//         }
//       }
//     }));
//   });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ratti-calculator"] && !Shopify.designMode) return;
  try {
    
        // script.js - Functionality for calculator
document.addEventListener('DOMContentLoaded', function() {
    const CARAT_TO_RATTI = 1.09375; // 1 carat = 1.09375 ratti
    const CARAT_TO_GRAM = 0.2; // 1 carat = 0.2 grams
    const CARAT_TO_MG = 200; // 1 carat = 200 mg

    const caratInput = document.getElementById('carat');
    const rattiInput = document.getElementById('ratti');
    const gramInput = document.getElementById('gram');
    const mgInput = document.getElementById('milligram');
    const resetBtn = document.getElementById('resetBtn');

    function updateFromCarat(carat) {
        if (carat === '') return;
        const value = parseFloat(carat) || 0;
        rattiInput.value = (value * CARAT_TO_RATTI).toFixed(4);
        gramInput.value = (value * CARAT_TO_GRAM).toFixed(4);
        mgInput.value = Math.round(value * CARAT_TO_MG);
    }

    function updateFromRatti(ratti) {
        if (ratti === '') return;
        const value = parseFloat(ratti) || 0;
        const carat = value / CARAT_TO_RATTI;
        caratInput.value = carat.toFixed(4);
        gramInput.value = (carat * CARAT_TO_GRAM).toFixed(4);
        mgInput.value = Math.round(carat * CARAT_TO_MG);
    }

    function updateFromGram(gram) {
        if (gram === '') return;
        const value = parseFloat(gram) || 0;
        const carat = value / CARAT_TO_GRAM;
        caratInput.value = carat.toFixed(4);
        rattiInput.value = (carat * CARAT_TO_RATTI).toFixed(4);
        mgInput.value = Math.round(carat * CARAT_TO_MG);
    }

    function updateFromMg(mg) {
        if (mg === '') return;
        const value = parseFloat(mg) || 0;
        const carat = value / CARAT_TO_MG;
        caratInput.value = carat.toFixed(4);
        rattiInput.value = (carat * CARAT_TO_RATTI).toFixed(4);
        gramInput.value = (carat * CARAT_TO_GRAM).toFixed(4);
    }

    caratInput.addEventListener('input', (e) => updateFromCarat(e.target.value));
    rattiInput.addEventListener('input', (e) => updateFromRatti(e.target.value));
    gramInput.addEventListener('input', (e) => updateFromGram(e.target.value));
    mgInput.addEventListener('input', (e) => updateFromMg(e.target.value));

    resetBtn.addEventListener('click', () => {
        caratInput.value = '';
        rattiInput.value = '';
        gramInput.value = '';
        mgInput.value = '';
    });
});
 

    
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rudraksha-tab-menu"] && !Shopify.designMode) return;
  try {
    
(function() {
  function initAccordion() {
    // Select all accordion buttons
    const faqButtons = document.querySelectorAll(".accordion-btn");

    faqButtons.forEach(btn => {
      // Remove any previous click listeners to avoid duplicates
      btn.replaceWith(btn.cloneNode(true));
    });

    // Re-select after cloning
    const updatedButtons = document.querySelectorAll(".accordion-btn");

    updatedButtons.forEach(btn => {
      btn.addEventListener("click", function() {
        const content = btn.nextElementSibling;
        const isOpen = content.style.maxHeight && content.style.maxHeight !== "0px";

        // Close all other accordions
        document.querySelectorAll(".accordion-content").forEach(c => {
          if (c !== content) {
            c.style.maxHeight = null;
          }
        });

        document.querySelectorAll(".accordion-btn svg").forEach(svg => {
          if (svg !== btn.querySelector("svg")) {
            svg.classList.remove("rotate-180");
          }
        });

        // Toggle current accordion
        if (!isOpen) {
          content.style.maxHeight = content.scrollHeight + "px";
          btn.querySelector("svg").classList.add("rotate-180");
        } else {
          content.style.maxHeight = null;
          btn.querySelector("svg").classList.remove("rotate-180");
        }
      });
    });
  }

  // Init on DOM ready
  if (document.readyState === "complete" || document.readyState === "interactive") {
    setTimeout(initAccordion, 100);
  } else {
    document.addEventListener("DOMContentLoaded", initAccordion);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-bar"] && !Shopify.designMode) return;
  try {
    
(function() {
  const bar = document.getElementById('custom-static-bar');
  const priceEl = document.getElementById('custom-static-bar-price');
  const compareEl = document.getElementById('custom-static-bar-compare');
  const addBtn = document.getElementById('custom-static-bar-add');
  const buyBtn = document.getElementById('custom-static-bar-buy');
  const loadingSpinner = document.getElementById('loading-spinner');
  const buyLoadingSpinner = document.getElementById('buy-loading-spinner');
  const toast = document.getElementById('toast');
  const productForm = document.querySelector('form[action*="/cart/add"], form[action="/cart/add"], .product-form form');
  const qtyInput = productForm ? productForm.querySelector('input[name="quantity"], input[name="qty"], .quantity input') : null;
  const variantInput = productForm ? productForm.querySelector('input[name="id"], select[name="id"], input[type="radio"][name="id"]:checked') : null;
  let lastVariantId = null;
  // Format price to Shopify's money format
  function formatMoney(cents) {
    try {
      if (window.Shopify && Shopify.formatMoney) {
        return Shopify.formatMoney(cents, bar.dataset.moneyFormat || '{{amount}}');
      }
    } catch (e) {}
    return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: '{{ cart.currency.iso_code }}' });
  }
  // Get current quantity from the input field
  function currentQty() {
    const q = qtyInput && qtyInput.value ? parseInt(qtyInput.value, 10) : 1;
    return isNaN(q) || q <= 0 ? 1 : q;
  }
  // Fetch variant data via Shopify API
  async function fetchVariantJSON() {
    let id = null;
    if (variantInput) {
      if (variantInput.tagName === 'INPUT' && variantInput.type === 'radio') {
        const checkedRadio = productForm.querySelector('input[type="radio"][name="id"]:checked');
        id = checkedRadio ? checkedRadio.value : null;
      } else {
        id = variantInput.value || (variantInput.options && variantInput.options[variantInput.selectedIndex]?.value);
      }
    }
    if (!id) {
      console.warn('No variant ID selected');
      return null;
    }
    try {
      const res = await fetch(`/variants/${id}.js`);
      if (!res.ok) return null;
      return await res.json();
    } catch (e) {
      console.error('Failed to fetch variant:', e);
      return null;
    }
  }
  // Update the sticky bar with the latest price
  async function updateBar() {
    const variant = await fetchVariantJSON();
    const qty = currentQty();
    if (!variant || variant.id == null) {
      priceEl.textContent = 'Select Variant';
      if (compareEl) compareEl.style.display = 'none';
      addBtn.disabled = true;
      addBtn.textContent = 'Select Variant';
      buyBtn.disabled = true;
      buyBtn.textContent = 'Select Variant';
      return;
    }
    if (variant.available === false) {
      priceEl.textContent = 'Unavailable';
      if (compareEl) compareEl.style.display = 'none';
      addBtn.disabled = true;
      addBtn.textContent = 'Unavailable';
      buyBtn.disabled = true;
      buyBtn.textContent = 'Unavailable';
      return;
    }
    const total = (variant.price || 0) * qty;
    priceEl.textContent = formatMoney(total);
    if (compareEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        compareEl.textContent = formatMoney((variant.compare_at_price || 0) * qty);
        compareEl.style.display = '';
      } else {
        compareEl.style.display = 'none';
      }
    }
    addBtn.disabled = false;
    addBtn.textContent = `Add to Cart (${qty})`; // Optional: show qty
    buyBtn.disabled = false;
    buyBtn.textContent = 'Buy Now';
  }
  // Handle Add to Cart with AJAX
  async function addToCart() {
    if (!productForm) {
      console.error('Product form not found');
      return;
    }
    const formData = new FormData(productForm);
    formData.set('quantity', String(currentQty()));
    // Show loading spinner
    loadingSpinner.style.display = 'inline-block';
    addBtn.disabled = true;
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      });
      const data = await res.json();
      if (!res.ok) {
        console.error('Add to cart failed:', data);
        throw new Error(data.message || 'Add to cart failed');
      }
      // Dispatch custom event after successful cart update
      document.dispatchEvent(new CustomEvent('cart:updated'));
      // Show Toast notification
      toast.style.display = 'block';
      setTimeout(() => {
        toast.style.display = 'none';
      }, 3000);
      // Update global cart (using Alpine.js or similar)
      updateGlobalCart();
    } catch (e) {
      console.error(e);
      addBtn.textContent = 'Try Again';
      setTimeout(() => {
        addBtn.textContent = addBtn.disabled ? 'Unavailable' : 'Add to Cart';
      }, 1500);
    } finally {
      // Hide loading spinner
      loadingSpinner.style.display = 'none';
      addBtn.disabled = false;
    }
  }
  // "Buy Now" Button: Add to Cart and redirect to checkout
  async function buyNow() {
    if (!productForm) {
      console.error('Product form not found');
      return;
    }
    const formData = new FormData(productForm);
    formData.set('quantity', String(currentQty()));
    // Show loading spinner
    buyLoadingSpinner.style.display = 'inline-block';
    buyBtn.disabled = true;

    if(dataState.style == 'Ring' || dataState.style === 'Pendant' || dataState.style === 'Loose Gemstone'){
      addSelectedVariantToCart(1);
    }
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      });
      const data = await res.json();
      if (!res.ok) {
        console.error('Add to cart failed:', data);
        throw new Error(data.message || 'Add to cart failed');
      }
      // Optionally show toast before redirect
      toast.textContent = 'Proceeding to checkout...';
      toast.style.display = 'block';
      setTimeout(() => {
        // window.location.href = '/checkout';
        window.breeze.startCheckout();
      }, 1000);
    } catch (e) {
      console.error(e);
      buyBtn.textContent = 'Try Again';
      setTimeout(() => {
        buyBtn.textContent = buyBtn.disabled ? 'Unavailable' : 'Buy Now';
      }, 1500);
    } finally {
      // Hide loading spinner (if not redirecting)
      buyLoadingSpinner.style.display = 'none';
      buyBtn.disabled = false;
    }
  }
  // Update global cart info (can trigger events if your theme listens for cart updates)
  function updateGlobalCart() {
    // Custom code to update the cart globally (e.g., cart icon, cart drawer)
    document.dispatchEvent(new CustomEvent('cart:updated'));
    console.log('Cart updated event dispatched');
  }
  // Event listeners for the buttons
  addBtn.addEventListener('click', (e) => {
    e.preventDefault();
    addToCart();
  });
  buyBtn.addEventListener('click', (e) => {
    e.preventDefault();
    buyNow();
  });
  // Update the sticky bar when quantity changes
  if (qtyInput) {
    qtyInput.addEventListener('change', updateBar);
    qtyInput.addEventListener('input', updateBar);
  }
  // Listen for variant changes (theme-specific event)
  document.addEventListener('variant:change', updateBar);
  // Also listen for radio changes if using radios for variants
  const variantRadios = document.querySelectorAll('input[type="radio"][name="id"]');
  variantRadios.forEach(radio => {
    radio.addEventListener('change', updateBar);
  });
  // Initial update
  updateBar();
  // Show sticky bar when scrolling 500px
  window.addEventListener('scroll', () => {
    if (window.scrollY >= 500) {
      bar.style.display = 'flex';
    } else {
      bar.style.display = 'none';
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zoomer"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const overlay = document.getElementById("zoomOverlay");
  const zoomedImg = document.getElementById("zoomedImage");
  const closeBtn = overlay.querySelector(".customzoomer-zoom-close");
  const leftBtn = overlay.querySelector(".customzoomer-zoom-nav.customzoomer-left");
  const rightBtn = overlay.querySelector(".customzoomer-zoom-nav.customzoomer-right");
  const imageContainer = overlay.querySelector(".customzoomer-zoom-image-container");
  const slides = Array.from(document.querySelectorAll("#track .slide img"));
  if (!slides.length) return;

  let currentIndex = 0;
  let isZoomed = false;
  let translateX = 0, translateY = 0;
  let startX = 0, startY = 0;
  let touchStartX = 0, touchStartY = 0;
  let touchCurrentX = 0, touchCurrentY = 0;
  let initialScale = 1;
  let lastTapTime = 0;
  let lastTapX = 0;
  let lastTapY = 0;

  function clampPan() {
    const rect = imageContainer.getBoundingClientRect();
    const scale = initialScale;
    const minX = rect.width * (1 - scale) / 2;
    const maxX = -minX;
    const minY = rect.height * (1 - scale) / 2;
    const maxY = -minY;
    translateX = Math.max(minX, Math.min(maxX, translateX));
    translateY = Math.max(minY, Math.min(maxY, translateY));
  }

  function adaptButtonColors() {
    if (zoomedImg.naturalWidth === 0 || zoomedImg.naturalHeight === 0 || !zoomedImg.complete) return;
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    canvas.width = zoomedImg.naturalWidth;
    canvas.height = zoomedImg.naturalHeight;
    ctx.drawImage(zoomedImg, 0, 0);
    const x = Math.floor(canvas.width / 2);
    const y = Math.floor(canvas.height * 0.9);
    const data = ctx.getImageData(x, y, 1, 1).data;
    const r = data[0] / 255;
    const g = data[1] / 255;
    const b = data[2] / 255;
    const lum = 0.299 * r + 0.587 * g + 0.114 * b;
    const buttons = document.querySelectorAll('.customzoomer-zoom-nav, .customzoomer-zoom-close');
    if (lum > 0.5) {
      // Light background: dark button bg, white text
      buttons.forEach(btn => {
        btn.style.background = 'rgba(0,0,0,0.8)';
        btn.style.color = '#fff';
        btn.style.borderColor = 'rgba(255,255,255,0.3)';
      });
    } else {
      // Dark background: light button bg, black text
      buttons.forEach(btn => {
        btn.style.background = 'rgba(255,255,255,0.8)';
        btn.style.color = '#000';
        btn.style.borderColor = 'rgba(0,0,0,0.3)';
      });
    }
  }

  function openZoom(index) {
    currentIndex = index;
    zoomedImg.onload = function() {
      adaptButtonColors();
    };
    zoomedImg.src = slides[index].src;
    overlay.classList.add("active");
    resetZoom();
  }

  function closeZoom() {
    overlay.classList.remove("active");
    resetZoom();
  }

  function resetZoom() {
    isZoomed = false;
    initialScale = 1;
    translateX = translateY = 0;
    imageContainer.style.cursor = 'grab';
    zoomedImg.style.transformOrigin = 'center center';
    updateTransform();
  }

  function updateTransform() {
    zoomedImg.style.transform = `scale(${initialScale}) translate(${translateX}px, ${translateY}px)`;
  }

  function zoomAtPoint(clientX, clientY, scale) {
    const rect = imageContainer.getBoundingClientRect();
    const x = (clientX - rect.left) / rect.width;
    const y = (clientY - rect.top) / rect.height;
    zoomedImg.style.transformOrigin = `${x * 100}% ${y * 100}%`;
    initialScale = scale;
    updateTransform();
  }

  function toggleZoom(clientX, clientY) {
    const newScale = isZoomed ? 1 : 2;
    if (newScale === 1) {
      translateX = 0;
      translateY = 0;
    }
    zoomAtPoint(clientX, clientY, newScale);
    isZoomed = (newScale > 1);
    imageContainer.style.cursor = isZoomed ? 'grab' : 'default';
    if (isZoomed) clampPan();
    // Ensure button colors are adapted after zoom
    setTimeout(adaptButtonColors, 100);
  }

  let isDragging = false;

  // Double click for mouse
  zoomedImg.addEventListener("dblclick", (e) => {
    e.stopPropagation();
    toggleZoom(e.clientX, e.clientY);
  });

  // Mouse drag to pan when zoomed
  imageContainer.addEventListener("mousedown", (e) => {
    if (!isZoomed || e.button !== 0) return;
    e.preventDefault();
    isDragging = true;
    startX = e.clientX - translateX;
    startY = e.clientY - translateY;
    imageContainer.style.cursor = "grabbing";

    function onMove(ev) {
      if (!isDragging) return;
      ev.preventDefault();
      translateX = ev.clientX - startX;
      translateY = ev.clientY - startY;
      clampPan();
      updateTransform();
    }

    function onUp(ev) {
      isDragging = false;
      imageContainer.style.cursor = "grab";
      clampPan();
      updateTransform();
      document.removeEventListener("mousemove", onMove);
      document.removeEventListener("mouseup", onUp);
    }

    document.addEventListener("mousemove", onMove);
    document.addEventListener("mouseup", onUp);
  });

  // Touch handling for pan, swipe, and double tap
  imageContainer.addEventListener("touchstart", (e) => {
    if (e.touches.length > 1) return;
    touchStartX = e.touches[0].clientX;
    touchStartY = e.touches[0].clientY;
    touchCurrentX = touchStartX;
    touchCurrentY = touchStartY;
    if (isZoomed) {
      startX = touchStartX - translateX;
      startY = touchStartY - translateY;
      isDragging = true;
      imageContainer.style.cursor = "grabbing";
    }
  }, { passive: false });

  imageContainer.addEventListener("touchmove", (e) => {
    if (e.touches.length > 1) return;
    e.preventDefault();
    touchCurrentX = e.touches[0].clientX;
    touchCurrentY = e.touches[0].clientY;
    const dx = touchCurrentX - touchStartX;
    const dy = touchCurrentY - touchStartY;

    if (isZoomed && isDragging) {
      translateX = touchCurrentX - startX;
      translateY = touchCurrentY - startY;
      clampPan();
      updateTransform();
    }
  }, { passive: false });

  imageContainer.addEventListener("touchend", (e) => {
    if (e.changedTouches.length !== 1) return;
    const touch = e.changedTouches[0];
    touchCurrentX = touch.clientX;
    touchCurrentY = touch.clientY;
    const dx = touchCurrentX - touchStartX;
    const dy = touchCurrentY - touchStartY;
    const now = Date.now();
    if (isDragging) {
      isDragging = false;
      imageContainer.style.cursor = "grab";
      clampPan();
      updateTransform();
      return;
    }
    if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) {
      // Swipe navigation when not zoomed
      const dir = dx > 0 ? -1 : 1;
      showNext(dir);
      return;
    }
    if (Math.abs(dx) < 10 && Math.abs(dy) < 10) {
      // Potential tap
      if (now - lastTapTime < 300 &&
          Math.abs(touch.clientX - lastTapX) < 20 &&
          Math.abs(touch.clientY - lastTapY) < 20) {
        // Double tap
        toggleZoom(touch.clientX, touch.clientY);
      }
      // Update last tap
      lastTapTime = now;
      lastTapX = touch.clientX;
      lastTapY = touch.clientY;
    }
  }, { passive: false });

  function showNext(dir = 1) {
    currentIndex = (currentIndex + dir + slides.length) % slides.length;
    // Smooth transition
    zoomedImg.style.transition = 'opacity 0.3s ease';
    zoomedImg.style.opacity = '0';
    setTimeout(() => {
      zoomedImg.onload = function() {
        adaptButtonColors();
      };
      zoomedImg.src = slides[currentIndex].src;
      resetZoom();
      zoomedImg.style.opacity = '1';
      zoomedImg.style.transition = 'transform 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
    }, 150);
  }

  slides.forEach((img, i) => {
    img.addEventListener("click", () => openZoom(i));
  });

  closeBtn.addEventListener("click", closeZoom);
  leftBtn.addEventListener("click", () => showNext(-1));
  rightBtn.addEventListener("click", () => showNext(1));

  overlay.addEventListener("click", (e) => {
    if (e.target === overlay) closeZoom();
  });

  // Prevent context menu on long press
  imageContainer.addEventListener("contextmenu", (e) => e.preventDefault());

  document.addEventListener("keydown", (e) => {
    if (!overlay.classList.contains("active")) return;
    if (e.key === "Escape") closeZoom();
    if (e.key === "ArrowRight") showNext(1);
    if (e.key === "ArrowLeft") showNext(-1);
  });
});

  } catch(e) { console.error(e); }
})();
})();
